<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script lang="ts" setup>
if (import.meta.prerender && useRoute().path === '/') {
  const routes = (await queryCollection('content').select('path').all()).map((page) => page.path)
  prerenderRoutes(routes)
}
</script>
